export default "__VITE_ASSET__BPSN2yKK__"